import { getDomainValueForCode, isEmpty, isFormValid, setError, syncProfileMarker } from '../../../../../library/Core/SmartFunctions';
import { ControlOnChangeArguments, DispatchEvent, State } from '../../../../../library/Core/SmartTypes';
import { AlumniProfileEditScreens } from '../../../../../services/screen-navigation.service';
import StudentService from '../../../../../services/student.service';
import { navigateToNextStep } from '../../../services/profile-next-step-navigator';
import levelOfSeniorityData from '../../defence-job/levelOfSeniority.json';

type RankLevels = {
    [rank: string]: string; 
};
  
type LevelOfSeniorityData = {
    [companyName: string]: RankLevels;  
};
const data = levelOfSeniorityData as LevelOfSeniorityData;

interface DomainItem {
    categoryCode: string;
    value: string;
    code: string;
}

interface Domain {
    [key: string]: DomainItem[];
}

export const handleNext = (
    event: React.SyntheticEvent<HTMLButtonElement>,
    state: State,
    dispatch: (dispatchEvent: DispatchEvent) => void,
    globalState: any,
    globalDispatch: (dispatchEvent: DispatchEvent) => void,
    sessionState: any,
    sessionDispatch: (dispatchEvent: DispatchEvent) => void
) => {
    event.preventDefault();
    const inValidDate = isValidDate(state, dispatch);
    const isValidDesignation=isValidDesignationRank(state,dispatch)
    const isImpersonatedSession = sessionStorage.getItem('is-impersonated-session') === 'YES';
    const customValidationPassed = isFormValidBasedOnCustomValidation(state, dispatch);
    if (!isImpersonatedSession && (!customValidationPassed || !inValidDate || !isValidDesignation || !isFormValid(state, dispatch))) {
        console.log("form_validation",state?.formValidationErrors)
        dispatch({ type: 'SHOW_ERRORS' });
        return;
    }   

    let defenceOutcomeWork = state?.data['defenceOutcomeWork'];
    if (defenceOutcomeWork && typeof defenceOutcomeWork === 'object' && !Array.isArray(defenceOutcomeWork)) {
        defenceOutcomeWork = [defenceOutcomeWork];
    } else if (!Array.isArray(defenceOutcomeWork)) {
        defenceOutcomeWork = [];
    }

    //companyId null then showing error hence handle this.
    defenceOutcomeWork = defenceOutcomeWork.filter((defence: any) => {
        return defence?.companyId && defence?.companyId !== null;
    });

    const IndustryData = Array.from(globalState?.domain || [])
        .filter(([key, value]: any) => {
            return value.some((item: any) => item.categoryCode === 'INDUSTRY_CODE');
        })
        .reduce((result: any, [key, value]: any) => {
            value.forEach((item: any) => {
                if (item.categoryCode === 'INDUSTRY_CODE') {
                    result[item.value] = item.code;
                }
            });
            return result;
        }, {}) as any;

        if (Array.isArray(defenceOutcomeWork)) {
            defenceOutcomeWork = defenceOutcomeWork.map((defence) => {
                const industryCode = IndustryData['Law Enforcement and Security Services'] ?? null;
                const { designationRank, ...rest } = defence;
        
                const seniorityLevelCode = getSeniorityLevelCode(
                    getDomainValueForCode(rest?.companyId, 'COMPANY_CODE', state),
                    getDomainValueForCode(designationRank, 'DEFENCE_RANK', state)
                );
        
                const existingJob = state?.data?.jobsList?.find((existingJob: any) => existingJob.id === defence.id);
                const updatedJob = {
                    ...existingJob, 
                    ...rest, 
                    recordTypeCode: 'JOINED', 
                    jobCategory: 'DEFENCE', 
                    isOutcome: 1,
                    industryCode,
                    designation: designationRank || '', 
                    seniorityLevelCode: null, //seniorityLevelCode || '',
                    // endDate: defence.isCurrent ? null : existingJob?.endDate || rest.endDate
                    endDate: defence.isCurrent === true ? null : existingJob?.endDate || rest?.endDate,
                };
        
                return updatedJob;
            });
        
            const jobsNotInDefenceWork = state?.data?.jobsList?.filter((existingJob: any) => 
                !defenceOutcomeWork.some((job: any) => job.id === existingJob.id)
            );
            defenceOutcomeWork = [...defenceOutcomeWork, ...jobsNotInDefenceWork];
    }
        
    let jobAppliedRecords = state?.data?.jobsApplied ?? [];
    let jobHistory = [...defenceOutcomeWork,...jobAppliedRecords];

    jobHistory = jobHistory.map((job: any) => ({
        ...job,
        countryCode: (job.isRemotelyWorking ? state?.data?.profile?.residingCountryCode : job.countryCode)?.trim() || null,
        cityCode: (job.isRemotelyWorking ? state?.data?.profile?.residingCityCode : job.cityCode)?.trim() || null
    }));

    StudentService.pageSave(
        state.routeInfo.id,
        state.routeInfo.pageName,
        StudentService.toStudentEntity({
            id: state.routeInfo.id,
            jobs: jobHistory,
            profile: state?.data['profile'],
        })
    ).then((response) => {
        if (response?.status === 200) {
            syncProfileMarker(state.routeInfo.id).then(() => {
                navigateToNextStep(AlumniProfileEditScreens.WORK_DETAILS, state, dispatch, sessionState, sessionDispatch);
            })
            
        }
    });
};

const getSeniorityLevelCode=(companyName:any,rank:any)=>{
    const companyData = data[companyName];
    if (!companyData) {
        return '';
    }
    const seniorityLevel = companyData[rank];
    if (!seniorityLevel) {
      return '';
    }
    return seniorityLevel;
}

const isFormValidBasedOnCustomValidation = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    const errorMessages = [] as any[];
    let isFormInvalid = false;
    const defenceOutcomeWork = state.data.defenceOutcomeWork;
    defenceOutcomeWork.forEach((defenceOutcomeWork: any, index: number) => {
        if (isEmpty(defenceOutcomeWork?.companyId) && isEmpty(defenceOutcomeWork?.otherCompany)) {
            isFormInvalid = true;
            setError(`defenceOutcomeWork.${index}.companyId`, [`Please enter "Name of the Company"`], dispatch);
        } else {
            setError(`defenceOutcomeWork.${index}.companyId`, [], dispatch);
        }
    });

    // Dispatch the validation errors to the state
    if (isFormInvalid) {
        dispatch({
            type: 'SET_FIELD_VALIDATION_ERRORS',
            payload: { dataKey: 'defenceOutcomeWork', errorMessages },
        });
    }
    return !isFormInvalid;
};

export const onCurrentJobSelectionChange = (props: ControlOnChangeArguments) => {
    const rowIndex = parseInt(props.parentDataKey.split('.').pop() as string);
    const jobs = props.state.data.defenceOutcomeWork.map((row: any, index: number) => {
        setError(`defenceOutcomeWork.${index}.endDate`, [], props.dispatch);
        return index == rowIndex ? { ...row, endYear: '', isCurrent: false } : { ...row, isCurrent: false };
    });
    props.dispatch({ type: 'SET_FIELD_VALIDATION_ERRORS', payload: { dataKey: `${props.parentDataKey}.jobStartAndEndDates`, value: [] } });

    props.dispatch({ type: 'CONTROL_VALUE_CHANGE', payload: { dataKey: 'defenceOutcomeWork', value: jobs } });
};

export const onStartDateChange = (props: ControlOnChangeArguments) => {
    alert(props.row.endDate);
    const errorMessages =
        new Date(props.value) > new Date(props.row.endDate) ? ['Start year should be less than or equal to End year'] : [];
    // props.dispatch({
    //     type: 'SET_FIELD_VALIDATION_ERRORS',
    //     payload: { dataKey: `${props.parentDataKey}.startDate`, errorMessages },
    // });

    props.errorMessages.push(errorMessages);
};

export const onEndDateChange = (props: ControlOnChangeArguments) => {
    const errorMessages =
        new Date(props.value) < new Date(props.row.startDate) ? ['End year should be greater than or equal to Start year'] : [];
    props.errorMessages.push(errorMessages);
};

export const handleCompleteLater = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    document.getElementsByClassName('modal').item(0)?.setAttribute('style', 'display:block');
};

const isValidDate = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    const defenceWorkData = state?.data['defenceOutcomeWork'];
    let isFormValid = true;
    defenceWorkData.forEach((defenceWork: any, index: number) => {
        if (isEmpty(defenceWork?.startDate)) {
            setError(`defenceOutcomeWork.${index}.startDate`, [`Please enter "Start Date" `], dispatch);
            isFormValid = false;
        } else {
            setError(`defenceOutcomeWork.${index}.startDate`, [], dispatch);
        }

        if (
            (defenceWork?.isCurrent === false || isEmpty(defenceWork?.isCurrent)) &&
            isEmpty(defenceWork?.endDate)
        ) {
            setError(`defenceOutcomeWork.${index}.endDate`, [`Please enter "End Date" `], dispatch);
            isFormValid = false;
        } else {
            setError(`defenceOutcomeWork.${index}.endDate`, [], dispatch);
        }

        if (new Date(defenceWork?.startDate) >= new Date(defenceWork?.endDate)) {
            console.log('Invalid date');
        }

        if (defenceWork?.isCurrent === false || isEmpty(defenceWork?.isCurrent)) {
            if (
                isEmpty(defenceWork?.endDate) ||
                new Date(defenceWork?.startDate) > new Date(defenceWork?.endDate)
            ) {
                setError(`defenceOutcomeWork.${index}.endDate`, [`End year should be greater than or equal to Start year`], dispatch);
                isFormValid = false;
            } else {
                setError(`defenceOutcomeWork.${index}.endDate`, [], dispatch);
            }
        }
    });

    return isFormValid;
};


const isValidDesignationRank = (
    state: State, 
    dispatch: (dispatchEvent: DispatchEvent) => void
): boolean => {
    const defenceWorkData = state?.data['defenceOutcomeWork'];
    let isFormValid = true;
    defenceWorkData.forEach((defenceWork: any, index: number) => {
        const companyId = defenceWork?.companyId; 
        const designationRank = defenceWork?.designationRank;
        const filteredRanks = state?.domain.get('DEFENCE_RANK')?.filter(rank => rank.parentCode === companyId);
        if (designationRank) {
            const isDesignationRankValid = filteredRanks?.some(rank => rank.code === designationRank);
            console.log(`Checking designationRank for index ${index}:`, designationRank, isDesignationRankValid);
            console.log("isDesignationRankValid",isDesignationRankValid)
            if (!isDesignationRankValid) {
                setError(`defenceOutcomeWork.${index}.designationRank`, [`Please enter Designation Rank`], dispatch);
                isFormValid = false;
            } else {
                setError(`defenceOutcomeWork.${index}.designationRank`, [], dispatch);
            }
        } else {
            setError(`defenceOutcomeWork.${index}.designationRank`, [`Please enter Designation Rank`], dispatch);
            isFormValid = false;
        }
    });

    return isFormValid;
};

